export default "__VITE_ASSET__XOsvjFYU__"